var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalander(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-icon.70346246 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "results-B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PG_Icon_Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_LIVE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M13.5 14.625H9.5625V10.6875H13.5V14.625ZM10.6875 13.5H12.375V11.8125H10.6875V13.5Z",
    fill: "#DE4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M13.5 9.5625H9.5625V5.625H13.5V9.5625ZM10.6875 8.4375H12.375V6.75H10.6875V8.4375Z",
    fill: "#DE4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    d: "M8.4375 9.5625H4.5V5.625H8.4375V9.5625ZM5.625 8.4375H7.3125V6.75H5.625V8.4375Z",
    fill: "#DE4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4",
    d: "M8.4375 14.625H4.5V10.6875H8.4375V14.625ZM5.625 13.5H7.3125V11.8125H5.625V13.5Z",
    fill: "#DE4D5F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M12.375 2.25V1.125H11.25V2.25H9.5625V1.125H8.4375V2.25H6.75V1.125H5.625V2.25H2.25V16.875H3.375V3.375H5.625V4.5H6.75V3.375H8.4375V4.5H9.5625V3.375H11.25V4.5H12.375V3.375H14.625V15.75H5.625C5.00625 15.75 4.5 16.2563 4.5 16.875H15.75V2.25H12.375Z",
    fill: "#DE4D5F"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalander);
export default __webpack_public_path__ + "static/media/icon-calander.65df833f10bc5e7701afa83ba833a413.svg";
export { ForwardRef as ReactComponent };